export const processoModel = {
  processo: function () {
    return {
      id: "",
      cliente_id: "",
      dt_inclusao: "",
      statusprocesso_id: "",
      tipoprocesso_id: "",
      categoriaprocesso_id: "",
      tp_cobertura: "",
      tp_gravidade: "",
      dt_sinistro: "",
      nr_documento: "", 
      acionado_id: "",
      responsavel_id: "",
      ds_sinistro: "",
      ds_danosinistro: "",
      ds_motnegado: "",
      captador_id: "",
      dt_pericia: "",
      pericia_dispensada: true,
      pendencia_processo: [],
    }
  },
}


// WEBPACK FOOTER //
// ./src/views/Processo/_model/index.js